import Vue from "vue";
Vue.config.devtools = true;
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import * as authentication from "./modules/Authentication/authentication";
import * as orders from "./modules/orders";
import * as organization from "./modules/organization";
import * as lsstype from "./modules/Orders/lsstype";
import * as paymentmethod from "./modules/Orders/paymentmethod";
import * as preOrderDetail from "./modules/Orders/submission/pre_order_details";
import partnerNationFinance from "./modules/partner_nation_finance_office";
import * as users from "./modules/users";
import * as orderUsers from "./modules/Orders/order_users";
import * as countries from "./modules/countries";
import * as operationTheaters from "./modules/operation_theaters";
import * as implementArrangment from "./modules/implement_arrangment";
import * as acsaAgreement from "./modules/acsa_agreement";
import * as agreementInformation from "./modules/Orders/submission/agreement_information";
import * as deliveryInformation from "./modules/Orders/submission/delivery_information";
import * as transactionInformation from "./modules/Orders/submission/transaction_information";
import * as costSummary from "./modules/Orders/submission/cost_summary";
import * as fundCitation from "./modules/Orders/invoice/fund_citation";
import * as orderFinanceSystem from "./modules/Orders/submission/order_finance_system";
import * as financeSystems from "./modules/Orders/finance_systems";
import * as unitMeasure from "./modules/Orders/unit_of_measure";
import * as stockClass from "./modules/Orders/stock_class";
import * as lineItem from "./modules/Orders/submission/line_item";
import * as lineItemReceipt from "./modules/Orders/receipt/line_item";
import * as lineItemInvoice from "./modules/Orders/invoice/line_item";
import * as replacementItem from "./modules/Orders/submission/replacement_item";
import * as replacementItemReceipt from "./modules/Orders/replacement/replacement_item";
import * as replacementItemInvoice from "./modules/Orders/invoice/replacement_item";
import * as authorizedRequestor from "./modules/Orders/authorized/authorized_requestor";
import * as authorizedAcceptor from "./modules/Orders/authorized/authorized_acceptor";
import * as authorizedRatifier from "./modules/Orders/authorized/authorized_ratifier";
import * as orderMetadata from "./modules/Orders/order_meta_data";
import * as adminUsers from "./modules/Admin/admin_users";
import * as transactions from "./modules/Admin/transactions";
import * as roles from "./modules/Admin/roles";
import * as operationTheater from "./modules/Admin/operation_theater";
import * as documents from "./modules/documents";
import * as financeOffice from "./modules/Orders/submission/finance_office";
import * as financialOffice from "./modules/financial_offices";
import * as supplyOfficial from "./modules/Orders/invoice/supply_official";
import * as inspectedReceivedBy from "./modules/Orders/receipt/inspected_received_by";
import * as role from "./modules/roles";
import * as notifications from "./modules/notifications";
import * as approvalStatus from "./modules/approval_status";
import * as auditLog from "./modules/audit_log";
import * as tab from "./modules/tab";
import * as fiscalYears from "./modules/fiscal_years";
import * as financeInformation from "./modules/Orders/finance_information";
import * as bankingInformation from "./modules/Orders/banking_information";
import * as disbursingCollectionInformation from "./modules/Orders/disbursing_collection_information";
import * as financialRepresentative from "./modules/Orders/completion/financial_representative";
import * as orderReport from "./modules/Report/order_report";
import * as returnReplacementReceiptAcknowledgment from "./modules/Orders/replacement/return_replacement_receipt_acknowledgment";
import * as insight from "./modules/Report/insight";
import * as subscription from"./modules/subscriptions";
import * as signature from"./modules/Orders/signature";
import * as reconciliationStatus from "./modules/Orders/completion/reconciliation_status";
import * as faq from "./modules/faq"
import * as emailExtension from "./modules/email_extension"
import invoiceInformation from "./modules/Orders/invoice/invoice_information";
import bankingOffice from "./modules/banking_office";
import moduleState from "./modules/module_state";
import * as tooltip from './modules/ToolTip/tooltip';
import * as services from "./modules/services";
import * as permissions from "./modules/permissions";
import * as userAuditlogs from "./modules/user_audit_log";


Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,

        reducer: state => ({
          authentication: state.authentication,
          lineItem: state.lineItem
        })
    }),
  ],
  actions: {
    clearAllStoreModules: function (context) {
      context.dispatch("orders/clearAll");
    },
    clearAllLogoutData: async function (context) {
      await context.dispatch("authentication/logout");
     // context.dispatch("notifications/clearData");
    },
    clearAllOrderData: function (context) {
      return new Promise((resolve) => {
        context.dispatch("permissions/clearPermissions");
        context.dispatch("preOrderDetail/clearData");
        context.dispatch("agreementInformation/clearData");
        context.dispatch("deliveryInformation/clearData");
        context.dispatch("transactionInformation/clearData");
        context.dispatch("financeOffice/clearData");
        context.dispatch("fundCitation/clearData");
        context.dispatch("authorizedRequestor/clearData");
        context.dispatch("authorizedAcceptor/clearData");
        context.dispatch("authorizedRatifier/clearData");
        context.dispatch("orderUsers/clearData");
        context.dispatch("orderMetadata/clearData");
        context.dispatch("inspectedReceivedBy/clearData");
        context.dispatch("documents/clearData");
        context.dispatch("documents/clearNewDocumentData");
        context.dispatch("supplyOfficial/clearData");
        context.dispatch("financeInformation/clearData");
        context.dispatch("bankingInformation/clearData");
        context.dispatch("disbursingCollectionInformation/clearData");
        context.dispatch("financialRepresentative/clearData");
        context.dispatch("auditLog/clearData");
        context.dispatch("tab/clearData");
        context.dispatch("returnReplacementReceiptAcknowledgment/clearData");
        context.dispatch("reconciliationStatus/clearData");
        context.dispatch("disbursingCollectionInformation/clearData");
        // context.dispatch("authentication/clearData");
        return resolve();
      });
    },
  },
  modules: {
    authentication,
    organization,
    lsstype,
    paymentmethod,
    preOrderDetail,
    orders,
    orderUsers,
    partnerNationFinance,
    agreementInformation,
    users,
    countries,
    operationTheaters,
    implementArrangment,
    acsaAgreement,
    deliveryInformation,
    transactionInformation,
    fundCitation,
    orderFinanceSystem,
    financeSystems,
    authorizedRequestor,
    authorizedAcceptor,
    authorizedRatifier,
    financeOffice,
    financialOffice,
    inspectedReceivedBy,
    unitMeasure,
    stockClass,
    lineItem,
    lineItemReceipt,
    lineItemInvoice,
    orderMetadata,
    adminUsers,
    transactions,
    roles,
    replacementItem,
    replacementItemReceipt,
    replacementItemInvoice,
    costSummary,
    documents,
    supplyOfficial,
    invoiceInformation,
    approvalStatus,
    role,
    auditLog,
    tab,
    fiscalYears,
    financeInformation,
    bankingInformation,
    disbursingCollectionInformation,
    financialRepresentative,
    orderReport,
    operationTheater,
    returnReplacementReceiptAcknowledgment,
    insight,
    notifications,
    subscription,
    signature,
    reconciliationStatus,
    faq,
    emailExtension,
    bankingOffice,
    moduleState,
      tooltip,
    services,
    permissions,
    userAuditlogs
  },
});
